import { array, boolean, defineAction, object, string } from '~/prix'
import systemSynchronizeAttendanceOlapAction from './systemSynchronizeAttendanceOlap.action.json'

const systemSynchronizeAttendanceOlapDefinition = defineAction({
  ...systemSynchronizeAttendanceOlapAction,
  input: object({
    useCustomTableList: boolean(),
    tablesAndSchemas: array(string()),
    propagationLevel: string(),
  }),
  output: object({}),
})
export default systemSynchronizeAttendanceOlapDefinition
